<template>
  <div>
    <p>
      Precast building panels allow rapid construction, high strength and durability, and minimal maintenance issues.
    </p>
    <carousel item="building-wall-panels" :images="images"></carousel>
  </div>
</template>

<script>
  import Carousel from '@/components/Carousel'

  export default {
    name: "BuildingWallPanels",
    components: {Carousel},
    data() {
      return {
        images: [
          'building-wall-panels-0.jpeg',
          'building-wall-panels-1.jpeg',
          'building-wall-panels-2.jpeg',
          'building-wall-panels-3.jpeg'
        ]
      }
    }
  }
</script>

<style scoped>

</style>